import { render } from "./CreateMedicationmain.vue?vue&type=template&id=f6f0fe34"
import script from "./CreateMedicationmain.vue?vue&type=script&lang=js"
export * from "./CreateMedicationmain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__